var React = require('react');

function Arrow (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M12.2318 0.904484L13.9827 2.65542L1.75093 14.8872L0 13.1363L12.2318 0.904484Z","fill":"#E4E4E4","key":0}),React.createElement("path",{"d":"M10.5233 2.65523L12.2743 0.904297L24.5061 13.1361L22.7551 14.887L10.5233 2.65523Z","fill":"#E4E4E4","key":1})]);
}

Arrow.defaultProps = {"width":"25","height":"15","viewBox":"0 0 25 15","fill":"none"};

module.exports = Arrow;

Arrow.default = Arrow;
